export const LocationTypeTranslation: { [key: number]: string } = {
  1: $localize`General`,
  2: $localize`Dropbox`,
  3: $localize`Care`,
  4: $localize`Pick-Up Station`,
};
